import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/dark.svg'
import _imports_1 from '@/assets/images/light.svg'


const _withScopeId = n => (_pushScopeId("data-v-0e4e5952"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer-container" }
const _hoisted_2 = { class: "setting-drawer-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-drawer-title" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "drawer-title" }, "主题风格设置")
], -1))
const _hoisted_4 = { class: "setting-drawer-block-checbox" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "dark"
}, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "setting-drawer-block-checbox-selectIcon",
  style: {"display":"block"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "light"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "setting-drawer-block-checbox-selectIcon",
  style: {"display":"block"}
}
const _hoisted_9 = { class: "drawer-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "主题颜色", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "drawer-title" }, "系统布局配置", -1))
const _hoisted_12 = { class: "drawer-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开启 TopNav", -1))
const _hoisted_14 = { class: "drawer-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开启 Tags-Views", -1))
const _hoisted_16 = { class: "drawer-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "固定 Header", -1))
const _hoisted_18 = { class: "drawer-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "显示 Logo", -1))
const _hoisted_20 = { class: "drawer-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "动态标题", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 保存配置 ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 重置配置 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Check = _resolveComponent("Check")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_theme_picker = _resolveComponent("theme-picker")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Refresh = _resolveComponent("Refresh")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    size: "280px",
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visible) = $event)),
    "with-header": false,
    "append-to-body": true,
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "setting-drawer-block-checbox-item",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleTheme('theme-dark')))
              }, [
                _hoisted_5,
                (_ctx.sideTheme === 'theme-dark')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Check, {
                            style: _normalizeStyle({ fill: _ctx.theme })
                          }, null, 8, ["style"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "setting-drawer-block-checbox-item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTheme('theme-light')))
              }, [
                _hoisted_7,
                (_ctx.sideTheme === 'theme-light')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Check, {
                            style: _normalizeStyle({ fill: _ctx.theme })
                          }, null, 8, ["style"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_theme_picker, {
                style: {"float":"right","height":"26px","margin":"-3px 8px 0 0"},
                onChange: _ctx.themeChange
              }, null, 8, ["onChange"])
            ])
          ]),
          _createVNode(_component_el_divider),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.topNavModel,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.topNavModel) = $event)),
              class: "drawer-switch"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.tagsViewModel,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tagsViewModel) = $event)),
              class: "drawer-switch"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.fixedHeaderModel,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fixedHeaderModel) = $event)),
              class: "drawer-switch"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.sidebarLogoModel,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sidebarLogoModel) = $event)),
              class: "drawer-switch"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.dynamicTitleModel,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dynamicTitleModel) = $event)),
              class: "drawer-switch"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_el_divider),
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            plain: "",
            onClick: _ctx.saveSetting
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Document)
                ]),
                _: 1
              }),
              _hoisted_22
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            size: "small",
            plain: "",
            onClick: _ctx.resetSetting
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Refresh)
                ]),
                _: 1
              }),
              _hoisted_23
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}